import React from "react";
import MUITooltip from "@mui/material/Tooltip";
import { getClassName } from "@sscs/utils";
import styles from "./tooltip.module.scss";
const availableHeightAllowance = 24;
const getAvailableHeight = (side, reference) => {
    if (side === "top") {
        return reference.y - availableHeightAllowance;
    }
    if (side === "bottom") {
        return (window.innerHeight -
            (reference.y + reference.height) -
            availableHeightAllowance);
    }
    return window.innerHeight - 2 * availableHeightAllowance;
};
const availableHeightModifier = {
    name: "tooltipAvailableHeight",
    enabled: true,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn: ({ state }) => {
        const side = state.placement.split("-")[0];
        const { reference } = state.rects;
        const available = getAvailableHeight(side, reference);
        state.elements.popper.style.setProperty("--tooltip-available-height", `${available}px`);
    },
};
const affordanceProps = {
    term: {
        className: styles.term,
        tabIndex: 0,
        describeChild: true,
        enterTouchDelay: 0,
        leaveTouchDelay: 5000,
    },
    graphic: {
        className: styles.graphic,
        tabIndex: 0,
        enterTouchDelay: 0,
        leaveTouchDelay: 5000,
    },
};
const CardBands = ({ header, body, footer, }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { "data-tooltip-header": true, className: styles.header }, header),
    React.createElement("div", { "data-tooltip-body": true, className: styles.body }, body),
    footer && (React.createElement("div", { "data-tooltip-footer": true, className: styles.footer }, footer))));
/**
 * The card tooltip's surface chrome without a popper — for a tooltip positioned by something other
 * than MUI (a chart library's own hover box). Same surface, header band and body/footer zones as the
 * `card` tooltip; positioning and any arrow are the caller's concern.
 */
const CardSurface = ({ header, children, footer, className, }) => (React.createElement("div", { className: getClassName(styles.surface, className) },
    React.createElement("div", { className: styles.scrollRegion },
        React.createElement(CardBands, { header: header, body: children, footer: footer }))));
const Tooltip = ({ tooltipType = "standard", disabled = false, trigger = "control", header, headerClassName, footer, fitContent = false, children, ...props }) => {
    var _a;
    if (disabled)
        return React.createElement(React.Fragment, null, children);
    const title = props.title ? (React.createElement("div", { className: styles.scrollRegion }, tooltipType === "card" ? (React.createElement(CardBands, { header: header, body: props.title, footer: footer })) : (props.title))) : (props.title);
    const labelledChild = typeof props.title === "string" &&
        trigger !== "term" &&
        !props.describeChild
        ? React.cloneElement(children, {
            "aria-label": (_a = children.props["aria-label"]) !== null && _a !== void 0 ? _a : props.title,
            "aria-hidden": undefined,
        })
        : children;
    const affordance = trigger === "control" ? undefined : affordanceProps[trigger];
    return (React.createElement(MUITooltip, { ...affordance, ...props, className: getClassName(affordance === null || affordance === void 0 ? void 0 : affordance.className, props.className), title: title, arrow: true, slotProps: {
            popper: {
                popperOptions: {
                    strategy: "fixed",
                    modifiers: [availableHeightModifier],
                },
            },
            tooltip: {
                "data-tooltip-type": tooltipType,
                "data-tooltip-fit-content": fitContent || undefined,
                className: tooltipType === "card"
                    ? getClassName(styles.surface, headerClassName)
                    : undefined,
                onClick: tooltipType === "card"
                    ? (event) => event.stopPropagation()
                    : undefined,
            },
            arrow: { "data-tooltip-type": tooltipType },
        } }, labelledChild));
};
Tooltip.CardSurface = CardSurface;
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map